import React, { useState, useRef } from 'react'
import { previewStatement, commitStatement, fetchStatementImports, recalcStatementImport, cancelStatementImport } from '../lib/api'

// Выписка Т‑Бизнеса → расходы по карте …6921 поровну на кандидатов, которые в этот день в Москве.
// Суммы с сервера приходят в копейках (целые числа).
const rub = kop => (kop / 100).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₽'
const rubStr = s => Number(s).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₽'
const fmtDay = iso => { const [y, m, d] = iso.split('-'); return `${d}.${m}.${y}` }

const box = { background: '#f9f9f7', border: '1px solid #ecece8', borderRadius: 10, padding: '12px 14px', marginBottom: 14 }
const btn = (primary) => ({ fontSize: 13, padding: '7px 14px', borderRadius: 8, cursor: 'pointer', fontWeight: 600,
  border: primary ? 'none' : '1px solid #d8d8d4', background: primary ? '#1a1a1a' : 'white', color: primary ? 'white' : '#333' })

export default function StatementImport() {
  const [files, setFiles] = useState([])
  const [preview, setPreview] = useState(null)
  const [overrides, setOverrides] = useState({})
  const [openDays, setOpenDays] = useState({})
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)
  const [result, setResult] = useState(null)
  const [journal, setJournal] = useState(null)
  const inputRef = useRef(null)

  const reset = () => { setFiles([]); setPreview(null); setOverrides({}); setOpenDays({}); setError(null); if (inputRef.current) inputRef.current.value = '' }

  async function onPick(e) {
    const picked = [...(e.target.files || [])]
    if (!picked.length) return
    reset(); setResult(null); setFiles(picked); setBusy(true)
    try { setPreview(await previewStatement(picked)) }
    catch (err) { setError(err.message + (err.details?.missing ? ': ' + err.details.missing.join(', ') : '')) }
    finally { setBusy(false) }
  }

  async function onCommit() {
    setBusy(true); setError(null)
    try {
      const r = await commitStatement(files, overrides)
      setResult(r); reset()
      if (journal) setJournal(await fetchStatementImports())
    } catch (err) { setError(err.message) }
    finally { setBusy(false) }
  }

  async function loadJournal() {
    if (journal) { setJournal(null); return }
    try { setJournal(await fetchStatementImports()) } catch (err) { setError(err.message) }
  }

  async function onRecalc(id) {
    setBusy(true)
    try { const r = await recalcStatementImport(id); setJournal(await fetchStatementImports()); alert(`Пересчитано. Нераспределено: ${rub(r.unallocated)}`) }
    catch (err) { alert('Ошибка: ' + err.message) } finally { setBusy(false) }
  }

  async function onCancel(imp) {
    if (!window.confirm(`Отменить импорт #${imp.id} (${imp.file_name})?\n\nУдалятся ${imp.added} операций на ${rubStr(imp.total)} и все их доли в карточках кандидатов. Ручные расходы не меняются.`)) return
    setBusy(true)
    try { await cancelStatementImport(imp.id); setJournal(await fetchStatementImports()) }
    catch (err) { alert('Ошибка: ' + err.message) } finally { setBusy(false) }
  }

  return (
    <div style={box}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700 }}>💳 Выписка по карте …6921</div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>Расходы делятся поровну на кандидатов, которые в этот день в Москве</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={btn(true)} disabled={busy} onClick={() => inputRef.current?.click()}>{busy && !preview ? 'Читаю…' : '⬆ Загрузить выписку'}</button>
          <button style={btn(false)} onClick={loadJournal}>{journal ? 'Скрыть журнал' : 'Журнал'}</button>
        </div>
        <input id="statement-file" ref={inputRef} type="file" accept=".zip,.csv" multiple hidden onChange={onPick} />
      </div>

      {error && <div style={{ marginTop: 10, fontSize: 13, color: '#c0392b', background: '#fdecea', borderRadius: 8, padding: '8px 10px' }}>{error}</div>}

      {result && (
        <div style={{ marginTop: 10, fontSize: 13, background: '#EAF3DE', color: '#27500A', borderRadius: 8, padding: '8px 10px' }}>
          ✅ Распределено: {result.days} дн., {result.added} операций на {rub(result.total)}
          {result.skipped > 0 && <> · уже были загружены: {result.skipped}</>}
          {result.unallocated > 0 && <> · <b>нераспределено {rub(result.unallocated)}</b> (нет кандидатов в Москве — после правки дат нажмите «Пересчитать» в журнале)</>}
        </div>
      )}

      {preview && (
        <div style={{ marginTop: 12 }}>
          <div style={{ fontSize: 13, marginBottom: 8 }}>
            {preview.files.join(', ')} · {preview.period.from && `${fmtDay(preview.period.from)}–${fmtDay(preview.period.to)}`} · карта {preview.card}<br />
            Найдено {preview.found} операций · новых <b>{preview.new}</b> на <b>{rub(preview.total)}</b>
            {preview.skipped > 0 && <> · уже загружено {preview.skipped}</>}
            {preview.unallocated > 0 && <span style={{ color: '#c0392b' }}> · нераспределено {rub(preview.unallocated)}</span>}
          </div>
          {preview.errors.length > 0 && (
            <div style={{ fontSize: 12, color: '#c0392b', marginBottom: 8 }}>
              {preview.errors.map((e, i) => <div key={i}>Строка {e.line}: {e.error} {e.merchant ? `· ${e.merchant}` : ''} {e.amount ? `· ${e.amount}` : ''}</div>)}
            </div>
          )}
          {preview.days.map(d => {
            const allLoaded = d.operations.every(o => o.loaded)
            const noOne = d.candidates === 0 && !allLoaded
            const cats = {}
            for (const o of d.operations) if (!o.loaded) { const c = overrides[o.external_id] || o.category; cats[c] = (cats[c] || 0) + o.amount }
            return (
              <div key={d.date} style={{ background: 'white', border: `1px solid ${noOne ? '#f5c6cb' : '#ecece8'}`, borderRadius: 8, padding: '8px 10px', marginBottom: 6, opacity: allLoaded ? 0.55 : 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, cursor: 'pointer', flexWrap: 'wrap' }} onClick={() => setOpenDays(o => ({ ...o, [d.date]: !o[d.date] }))}>
                  <div style={{ fontSize: 13 }}>
                    <b>{fmtDay(d.date)}</b>{' · '}
                    {allLoaded ? 'уже загружено'
                      : noOne ? <span style={{ color: '#c0392b' }}>в Москве никого — сумма уйдёт в нераспределённые</span>
                      : <span title={d.names.join(', ')}>в Москве {d.candidates} чел.</span>}
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
                    {rub(d.total)}{d.candidates > 0 && d.total > 0 && <span style={{ fontWeight: 400, color: '#888' }}> · ≈{rub(Math.floor(d.total / d.candidates))} на чел.</span>}
                    <span style={{ color: '#aaa', marginLeft: 6 }}>{openDays[d.date] ? '▲' : '▼'}</span>
                  </div>
                </div>
                <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>
                  {Object.entries(cats).map(([c, k]) => `${c}: ${rub(k)}`).join(' · ')}
                </div>
                {openDays[d.date] && (
                  <div style={{ marginTop: 6, borderTop: '1px solid #f0f0ec', paddingTop: 6 }}>
                    {d.operations.map(o => (
                      <div key={o.external_id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, padding: '3px 0', flexWrap: 'wrap', color: o.loaded ? '#aaa' : '#333' }}>
                        <span style={{ flex: '1 1 200px', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>{o.merchant || '—'} <span style={{ color: '#aaa' }}>MCC {o.mcc} · {o.source_category}</span></span>
                        <span style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>{rub(o.amount)}</span>
                        {o.loaded ? <span>уже загружена</span> : (
                          <select id={`stmt-cat-${o.external_id}`} value={overrides[o.external_id] || o.category}
                            onChange={e => setOverrides(v => ({ ...v, [o.external_id]: e.target.value }))}
                            style={{ fontSize: 12, padding: '2px 6px', borderRadius: 6, border: '1px solid #ddd' }}>
                            {preview.categories.map(c => <option key={c} value={c}>{c}</option>)}
                          </select>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )
          })}
          <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
            <button style={btn(true)} disabled={busy || preview.new === 0} onClick={onCommit}>{busy ? 'Распределяю…' : preview.new === 0 ? 'Эта выписка уже загружена' : `Распределить ${rub(preview.total)}`}</button>
            <button style={btn(false)} disabled={busy} onClick={reset}>Отмена</button>
          </div>
        </div>
      )}

      {journal && (
        <div style={{ marginTop: 12 }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>Журнал загрузок</div>
          {journal.length === 0 && <div style={{ fontSize: 12, color: '#888' }}>Выписок ещё не загружали</div>}
          {journal.map(i => (
            <div key={i.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap', fontSize: 12, padding: '6px 0', borderBottom: '0.5px solid #ecece8' }}>
              <div style={{ minWidth: 0, flex: '1 1 260px' }}>
                <b>#{i.id}</b> {i.period_from && `${fmtDay(i.period_from)}–${fmtDay(i.period_to)}`} · {i.file_name}<br />
                <span style={{ color: '#888' }}>
                  {i.user_name}, {new Date(i.created_at).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                  {' · '}найдено {i.found}, добавлено {i.added}, пропущено {i.skipped} · {rubStr(i.total)} на {i.candidates} канд.
                  {Number(i.unallocated) > 0 && <span style={{ color: '#c0392b' }}> · нераспределено {rubStr(i.unallocated)}</span>}
                  {i.recalculated_at && ` · пересчитано ${new Date(i.recalculated_at).toLocaleDateString('ru-RU')}`}
                </span>
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button style={{ ...btn(false), fontSize: 12, padding: '4px 10px' }} disabled={busy} onClick={() => onRecalc(i.id)}>Пересчитать</button>
                <button style={{ ...btn(false), fontSize: 12, padding: '4px 10px', color: '#c0392b', borderColor: '#f5c6cb' }} disabled={busy} onClick={() => onCancel(i)}>Отменить</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
